import React from "react";
import { MANAGMENT, ADMINISTRATION } from "../data";
import Container from "../components/container";
import HeroSmall from "../components/hero-small.js";

const About = props => (
  <main>
    <HeroSmall 
      title="Entrepreneurs Evolving into Business People" 
      desc="Get to know us better" 
    />

    <Container customClassName="page-container">
      <div className="page-sixth">
        <p>The international economy scene coexists with businesses in a more and more complex, interconnected, and faster moving environment. Such events have to be veraciously followed by economists, business leaders, and policymakers through analytic tools in order to cater a broad and far-reaching perspective. To avoid loss of hidden potentials, unbalanced growth, and de trop market failures - we have committed ourselves to ventures of all kind that want to change the world for the better.</p>

        <h4>Our Pledge to Founders</h4>

        <ul>
          <li>Wisdom in managerial operations</li>
          <li>To listen first, talk second</li>
          <li>Expeditious responsiveness</li>
          <li>Rationality in decision-making situations</li>
          <li>Allegiance in business</li>
        </ul>

        <hr />

        <h4>The beginning of time</h4>

        <p>With roots dating back to 2004, and a single office in Montenegro, now it’s spread to eleven different pins on the global map. With assets ranging from a few hundred thousand to multi-million dollars, Webb Holding can call itself THE place to go to for investments and tech-related business consulting.</p>
        <p>We identify markets and build technologies and online services used by millions of people around the world each day.</p>

        <p><b>Everything we do must be in the best interest of all parties involved</b></p>

        <p>Through our offices, we employ over 100 people that are mostly engaged in R&D related activities. We maintain an open, dynamic culture that allows us to bring quality products to different markets quickly and efficiently.</p>
        <p>The idea is to encourage our people and foster an open mind while constantly thinking outside the box. It is for this very freedom of creativity that we are committed to a healthy balance between work and personal lives, enabling our people to meet their work commitments while juggling with personal responsibilities as well.</p>

        <h4>Our Approach</h4>

        <p>Our investment philosophy is to deliver immense profits for companies.</p>

        <ul>
          <li><b>We Discover</b> great innovation in tech.</li>
          <li><b>We Guard</b> brands and their identity.</li>
          <li><b>We Shape</b> business models for better opportunities.</li>
          <li><b>We Enhance</b> companies in various enviroments.</li>
        </ul>

        <hr />

        <h4 id="testimonials">Not just our portfolio - but our partners</h4>

        <span><b>Adwe testimonial</b>:</span>
        <div className="testimonial">
          <i>“Definitely more of a partner than an investor.”</i>
        </div>

        <br />

        <span><b>Abago Testimonial</b>:</span>
        <div className="testimonial">
          <i>“Our company deals with flights, but none of our fares reach as far as Webb Holding.”</i>
        </div>

        <br />

        <h4 id="coorporate-responsibility">Corporate Social Responsibility</h4>

        <p>Webb Holding is proponent of social and environmental responsibility. We nurture ethical values, fairness in conducting business while protecting the environment.</p>
        <p>Reducing carbon footprints is one important focus as a social responsibility for us and we do our best to lower-carbon economy. By operating effectively and advancing clean technology we are working on upgrading and improving environmental solutions and our ways of contribution as for that part.</p>
        <p>We are committed to enhancing education as a relevant part of our employees as well as society in general. We empower our employees and other individuals or small businesses with services, products and knowledge in order to improve their professional lives as well as their quality of life.</p>
        <p>By treating our employees fairly and ethically we are advocates of long term growth and success. Diversity and social inclusion are part of our commitment and we ensure to respect and value all people involved in our business, communities and we tend to include all individuals regardless (following but not limited to) race, gender, sexual orientation, gender, ethnic origin, beliefs, culture, age, physical and mental abilities, life status, work status or employment level.</p>
        <p>Supporting worthy causes by donations in the form of money, products or services are also one part of our corporate responsibility aspects.</p>
        
        <h4 id="team">Team</h4>
        <p>Our team is consisted of people who enrich our existence by bringing a wealth of experience and we are led by those who constantly grow and create challenges on a daily basis.</p>

        {/* <div className="half-row">
          <div className="half-column">
            <h5>Managment</h5>
            <ul>
              {MANAGMENT.map(item => <li><a href={"mailto:" + item.email}><b>{item.name}</b><br />{item.title}</a></li>)}
            </ul>
          </div>

          <div className="half-column">
            <h5>Administration</h5>
            <ul>
              {ADMINISTRATION.map(item => <li><a href={"mailto:" + item.email}><b>{item.name}</b><br />{item.title}</a></li>)}
            </ul>
          </div>
        </div> */}

      </div>

    </Container>
  </main>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.js